import { configureStore } from '@reduxjs/toolkit';
import sitesReducer from './slices/sitesSlice';
import authReducer from './slices/authSlice';
import scenarioReducer from './slices/scenarioSlice';

export const store = configureStore({
  reducer: {
    sites: sitesReducer,
    auth: authReducer,
    scenario: scenarioReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
